import { GET_COUNTRIES } from "@/actions/GET_COUNTRIES.ts";
import { WarningToast } from "@/components/Notifications/WarningToast.tsx";
import { Country } from "@/helpers/types/types.ts";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export interface GetCountriesResponse {
  countries: Country[];
}
export const useGetCountries = () => {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery<GetCountriesResponse>(GET_COUNTRIES);

  useEffect(() => {
    if (error) {
      console.error("GET_COUNTRIES failed:", error.message);
      toast.custom(<WarningToast message={t("error")} />);
    }
  }, [error, t]);

  return {
    countries: data?.countries || [],
    getCountriesLoading: loading,
  };
};
